import {useSyncExternalStore} from "react";
import {livePreview} from "../utils/livePreview";
import {useApp} from "../app.context";

// Live Preview status lines — shown in the Settings "Debug Info" section
// (moved out of the sidebar LivePreviewControl). Subscribes to the same store.
function LivePreviewDebugInfo() {
    const status = useSyncExternalStore(livePreview.subscribe, livePreview.getSnapshot);
    const {playFabId, displayName} = useApp();

    if (!status.enabled)
        return <p style={{color: 'var(--muted-text-color)', fontSize: 13, margin: 0}}>Live Preview is off.</p>;

    const statusText = !status.uid ? 'needs your PlayFab id'
        : !status.connected ? 'connecting…'
        : status.receivers === 0 ? 'no game listening'
        : `${status.receivers} game session${status.receivers > 1 ? 's' : ''} · push #${status.lastPushSeq}`;

    // e.g. "local · debug (1) · release" — connected relays only; the count marks
    // where the listening game sessions actually are.
    const relayText = status.relays.filter(r => r.connected)
        .map(r => r.receivers > 0 ? `${r.label} (${r.receivers})` : r.label)
        .join(' · ');

    return (
        <div className={'layout vertical'} style={{gap: 4}}>
            <p className={'muted-text'} style={{margin: 0}}>{statusText}</p>
            {status.branch &&
                <p className={'muted-text'} style={{margin: 0}}
                   title={'A game applies pushes only while it runs this branch.'}>
                    {`branch: ${status.branch}`}
                </p>}
            {relayText &&
                <p className={'muted-text'} style={{margin: 0}}
                   title={'Relays this publisher is connected to. The game build\'s profile decides which relay it listens on, so the editor publishes to all of them.'}>
                    {`relays: ${relayText}`}
                </p>}
            {playFabId
                ? <p className={'muted-text'} style={{margin: 0}}>{`as ${displayName || playFabId}`}</p>
                : <p className={'muted-text'} style={{margin: 0}}>account id unavailable — re-login required</p>}
            {status.logicChanges > 0 &&
                <p className={'muted-text'} style={{margin: 0}}>
                    {`${status.logicChanges} logic change${status.logicChanges > 1 ? 's' : ''} need an export`}
                </p>}
        </div>
    );
}

export default LivePreviewDebugInfo;
